module.exports = __webpack_public_path__ + "img/elec_charge_online.49797499.png";